import React from 'react';
import { IIcon } from './Icon';

export const LockIcon = ({ color = '#FFD700' }: IIcon) => (
  <svg width="16" height="16" fill={color} viewBox="0 0 16 16">
    <path d="M8 1a3.5 3.5 0 0 0-3.5 3.5V7A1.5 1.5 0 0 0 3 8.5v5A1.5 1.5 0 0 0 4.5 15h7a1.5 1.5 0 0 0 1.5-1.5v-5A1.5 1.5 0 0 0 11.5 7V4.5A3.5 3.5 0 0 0 8 1zm2 6H6V4.5a2 2 0 1 1 4 0V7a.5.5 0 0 1 0 0z" />
  </svg>
);
